import { useGetStoresQuery } from '@lotta/self-service/lottery-fe/data-access-state';

/**
 * Get stores for a retailunit/language. Will fall back to the default
 * language if the language is not part of that retailunits languages.
 *
 * For convinence, it allows retailUnitData to be undefined but will not
 * fetch the stores until it is not.
 */
export const useStores = ({
  retailUnit,
  language,
  retailUnitData,
}: {
  retailUnit: string;
  language: string;
  retailUnitData?: { retailUnit: { languages: Array<string>; defaultLanguage: string } };
}) => {
  let skip = true;

  if (retailUnitData) {
    skip = false;
    if (!retailUnitData.retailUnit.languages.includes(language)) {
      language = retailUnitData.retailUnit.defaultLanguage;
    }
  }

  return useGetStoresQuery({ retailUnit, language }, { skip });
};
